import { render, staticRenderFns } from "./tax-modal.vue?vue&type=template&id=76302778"
import script from "./tax-modal.vue?vue&type=script&lang=js"
export * from "./tax-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports